import { useState } from 'react';
import Reveal from '@/components/Reveal';
import { homeMock } from '@/mocks/home';

export default function Features() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(0);
  const cardClasses = [
    'md:col-span-4 md:h-[460px]',
    'md:col-span-5 md:h-[380px] md:mt-24',
    'md:col-span-3 md:h-[520px] md:mt-12',
  ];

  return (
    <section id="features" className="w-full bg-mahjong-bg py-32 md:py-40">
      <div className="px-6 md:px-10 lg:px-16">
        {/* Title */}
        <div className="mb-12 grid gap-6 md:mb-14 md:grid-cols-12 md:items-start">
          <div className="md:col-span-2">
            <p
              className="font-sans text-xs tracking-[0.45em] text-mahjong-warm"
              style={{ writingMode: 'vertical-rl' }}
            >
              FEATURE
            </p>
          </div>
          <Reveal className="md:col-span-9 md:col-start-3" variant="slide-left">
            <h2 className="whitespace-pre-line font-serif text-3xl font-bold leading-relaxed text-mahjong-dark md:text-5xl lg:text-6xl">
              {homeMock.features.title}
            </h2>
          </Reveal>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-6">
          {homeMock.features.items.map((item, index) => (
            <Reveal
              key={item.title}
              delay={index * 120}
              className={`${cardClasses[index]} ${
                index % 2 === 0 ? 'ml-auto max-w-[85%]' : 'mr-auto max-w-[90%]'
              } md:max-w-none`}
            >
              <div
                className={`relative h-[420px] cursor-pointer overflow-hidden rounded-2xl transition-all duration-500 ease-out hover:-rotate-1 hover:shadow-2xl md:h-full ${
                  hoveredIndex === index ? 'md:scale-[1.02]' : 'md:scale-100'
                }`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(0)}
              >
                {/* Background Image */}
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700"
                  style={{
                    transform:
                      hoveredIndex === index ? 'scale(1.08)' : 'scale(1)',
                  }}
                />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h3 className="mb-2 font-serif text-xl font-bold text-white md:text-2xl">
                    {item.title}
                  </h3>
                  <p
                    className={`font-sans text-sm leading-relaxed text-white/80 transition-all duration-500 ${
                      hoveredIndex === index
                        ? 'translate-y-0 opacity-100'
                        : 'translate-y-4 opacity-0 md:translate-y-0 md:opacity-100'
                    }`}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}